var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4884 9.2047H19.75V9.16666H11.5V12.8333H16.6806C15.9248 14.9678 13.8939 16.5 11.5 16.5C8.46264 16.5 6.00001 14.0374 6.00001 11C6.00001 7.96262 8.46264 5.49999 11.5 5.49999C12.9021 5.49999 14.1776 6.02891 15.1488 6.89287L17.7416 4.30008C16.1044 2.77429 13.9145 1.83333 11.5 1.83333C6.43772 1.83333 2.33334 5.9377 2.33334 11C2.33334 16.0623 6.43772 20.1667 11.5 20.1667C16.5623 20.1667 20.6667 16.0623 20.6667 11C20.6667 10.3854 20.6034 9.78541 20.4884 9.2047Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39026 6.73337L6.40197 8.94208C7.21688 6.92449 9.19047 5.49999 11.5 5.49999C12.9021 5.49999 14.1776 6.02891 15.1488 6.89287L17.7416 4.30008C16.1044 2.77429 13.9145 1.83333 11.5 1.83333C7.97909 1.83333 4.92568 3.82112 3.39026 6.73337Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.1667C13.8678 20.1667 16.0192 19.2605 17.6458 17.787L14.8087 15.3862C13.8575 16.1097 12.6951 16.5009 11.5 16.5C9.11576 16.5 7.0913 14.9797 6.32864 12.8581L3.33939 15.1612C4.85647 18.1298 7.93739 20.1667 11.5 20.1667Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4884 9.20471H19.75V9.16667H11.5V12.8333H16.6805C16.319 13.8492 15.6678 14.7369 14.8073 15.3867L14.8087 15.3858L17.6458 17.7865C17.445 17.969 20.6667 15.5833 20.6667 11C20.6667 10.3854 20.6034 9.78542 20.4884 9.20471Z",
    fill: "#469B12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.2c04d4fb4443fd4b5913e3f359933ec0.svg";
export { ForwardRef as ReactComponent };